/**
 * The study's device checks, as pure functions over what the browser reports.
 * `TechCheck.tsx` is the screen; this is the rule.
 */

export interface DeviceFacts {
  userAgent: string
  maxTouchPoints: number
  innerWidth: number
}

/** The narrowest touch screen still treated as a desktop (a large tablet with a keyboard). */
export const MIN_TOUCH_DESKTOP_WIDTH = 820

const MOBILE_UA = /Android|iPhone|iPad|iPod|Mobile|Silk|Kindle|BlackBerry|Opera Mini|IEMobile/i

/** `true` for a desktop or laptop: the game needs a keyboard. */
export function isDesktop(device: DeviceFacts): boolean {
  if (MOBILE_UA.test(device.userAgent)) return false
  if (device.maxTouchPoints > 0 && device.innerWidth < MIN_TOUCH_DESKTOP_WIDTH) return false
  return true
}

export interface ApiFacts {
  getUserMedia: boolean
  RTCPeerConnection: boolean
  MediaRecorder: boolean
}

/** The APIs a study session cannot run without, missing ones first. */
export function missingApis(apis: ApiFacts): string[] {
  return (Object.keys(apis) as Array<keyof ApiFacts>).filter((name) => !apis[name])
}

/** When the microphone prompt has been open long enough to need a hint, then a way out. */
export const MIC_HINT_AFTER_MS = 20_000
export const MIC_GIVE_UP_AFTER_MS = 60_000
